<div class="min-h-screen bg-white" style="font-family: sans-serif;">

  <!-- ═══ LOADING ═══ -->
  <div *ngIf="isLoading" class="max-w-[1100px] mx-auto px-4 py-8">
    <div class="flex gap-3 justify-center mb-8">
      <div *ngFor="let i of [1,2,3,4,5]" class="h-10 bg-gray-200 rounded-full w-32 animate-pulse"></div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div class="aspect-square bg-gray-200 animate-pulse"></div>
      <div class="space-y-5">
        <div class="h-28 bg-gray-100 animate-pulse border-2 border-dashed border-gray-200"></div>
        <div class="flex gap-0">
          <div *ngFor="let i of [1,2,3,4,5,6]" class="h-9 w-20 bg-gray-200 animate-pulse border border-gray-100"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ MAIN ═══ -->
  <div *ngIf="!isLoading">

    <!-- Error toast -->
    <div *ngIf="errorMsg"
      class="fixed top-4 left-1/2 -translate-x-1/2 z-[99998] bg-red-600 text-white px-6 py-3 rounded-lg shadow-xl text-sm font-medium max-w-[500px] text-center animate-bounce">
      {{ errorMsg }}
      <button (click)="errorMsg = ''" class="ml-3 text-white/70 hover:text-white font-bold">✕</button>
    </div>

    <!-- Cart success toast -->
    <div *ngIf="cartSuccess"
      class="fixed top-4 left-1/2 -translate-x-1/2 z-[99998] bg-green-600 text-white px-6 py-3 rounded-lg shadow-xl text-sm font-medium max-w-[500px] text-center flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      Added to cart successfully!
      <button (click)="cartSuccess = false" class="ml-3 text-white/70 hover:text-white font-bold">✕</button>
    </div>

    <!-- TAB BAR — Mobile: icons (sticky) -->
    <div class="md:hidden bg-white border-b border-gray-200 sticky top-0 z-30">
      <div class="flex justify-around px-2 py-2">
        <button *ngFor="let tab of visibleTabs" (click)="setTab(tab.slug)"
          [class]="'flex flex-col items-center gap-1 px-2 py-1.5 rounded-lg transition-all min-w-[56px] '
            + (activeTab === tab.slug ? 'bg-[#8B1A1A]/10 border border-[#8B1A1A]' : 'border border-transparent')">
          <img [src]="tabIcons[tab.slug]" [alt]="tab.name" class="w-8 h-8 object-contain rounded"
            [class.opacity-100]="activeTab === tab.slug" [class.opacity-50]="activeTab !== tab.slug" />
          <span [class]="'text-[9px] font-bold leading-tight text-center ' + (activeTab === tab.slug ? 'text-[#8B1A1A]' : 'text-gray-400')">
            {{ tab.name }}
          </span>
        </button>
      </div>
    </div>

    <!-- ═══ TWO-COLUMN LAYOUT ═══ -->
    <div class="max-w-[1100px] mx-auto px-4 py-6 md:py-8">
      <div class="grid grid-cols-1 md:grid-cols-[42%_58%] gap-4 md:gap-6 items-start">

        <!-- ══ LEFT: LIVE PREVIEW ══ -->
        <div class="md:sticky md:top-4">
          <!-- ROOM PREVIEW — only when photo uploaded -->
          <div *ngIf="imagePath && showRoomPreview" class="relative bg-[#e8e4de] overflow-hidden rounded" style="min-height:300px;">
            <div class="absolute left-1/2 -translate-x-1/2 z-10" style="top:15%">
              <div *ngIf="previewLayout === 'frame'"
                [style.border-width.px]="frameBorderWidth"
                [style.border-image]="frameBorderImage"
                style="border-style:solid; line-height:0;">
                <div [style.padding.px]="mat3Padding" [style.background]="mount3Background">
                  <div [style.padding.px]="mat2Padding" [style.background]="mount2Background">
                    <div [style.padding.px]="mat1Padding" [style.background]="mount1Background">
                      <img [src]="imagePath" style="max-width:120px;max-height:90px;display:block;" />
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="previewLayout === 'print'" style="line-height:0;">
                <img [src]="imagePath" style="max-width:120px;max-height:90px;display:block;box-shadow:0 2px 8px rgba(0,0,0,.2);" />
              </div>
              <div *ngIf="previewLayout === 'canvas'" style="position:relative;line-height:0;">
                <img [src]="imagePath" style="max-width:120px;max-height:90px;display:block;box-shadow:3px 3px 0 #555;" />
              </div>
            </div>
            <img [src]="activeRoom.image" alt="Room" class="w-full object-cover" />
          </div>

          <!-- MAIN PREVIEW — not room view (click opens upload dialog) -->
          <div *ngIf="!showRoomPreview" (click)="onAddPhoto($event)"
            class="flex items-center justify-center overflow-hidden min-h-[350px] md:min-h-[500px] cursor-pointer">

            <!-- FRAME LAYOUT (framing / frame_only) — shows frame+mount even with placeholder -->
            <div *ngIf="previewLayout === 'frame'"
              [style.border-width.px]="frameBorderWidth"
              [style.border-image]="frameBorderImage"
              [style.border-radius]="roundedShape && canRoundShape ? '50%' : null"
              [style.overflow]="roundedShape && canRoundShape ? 'hidden' : null"
              style="border-style:solid; line-height:0; max-width:85%;">
              <div [style.padding.px]="mat3Padding" [style.background]="mount3Background">
                <div [style.padding.px]="mat2Padding" [style.background]="mount2Background">
                  <div [style.padding.px]="mat1Padding" [style.background]="mount1Background">
                    <img [src]="imagePath || defaultPlaceholder" [style.max-width]="printSizeW" [style.max-height]="printSizeH"
                      [style.filter]="imageFilterCss"
                      style="display:block;width:100%;" />
                  </div>
                </div>
              </div>
            </div>

            <!-- PRINT LAYOUT (print_only) — plain image, no frame -->
            <div *ngIf="previewLayout === 'print'" style="line-height:0;">
              <img [src]="imagePath || defaultPlaceholder" [style.max-width]="printSizeW" [style.max-height]="printSizeH"
                [style.filter]="imageFilterCss"
                style="display:block;width:100%;box-shadow:0 2px 12px rgba(0,0,0,.15);" />
            </div>

            <!-- CANVAS LAYOUT — 3D effect -->
            <div *ngIf="previewLayout === 'canvas'" style="position:relative;line-height:0;">
              <img [src]="imagePath || defaultPlaceholder" [style.max-width]="printSizeW" [style.max-height]="printSizeH"
                [style.filter]="imageFilterCss"
                style="display:block;width:100%;box-shadow:4px 4px 0 #555, 5px 5px 8px rgba(0,0,0,.3);" />
            </div>
          </div>

          <!-- Room preview thumbnails -->
          <div class="flex items-center gap-2 mt-3">
            <button (click)="toggleRoomPreview()"
              [class]="'text-[10px] font-bold px-3 py-1.5 rounded border transition-all '
                + (showRoomPreview ? 'bg-[#8B1A1A] text-white border-[#8B1A1A]' : 'bg-white text-gray-500 border-gray-300 hover:border-[#8B1A1A]')">
              {{ showRoomPreview ? 'Close Room View' : 'Room View' }}
            </button>
            <div *ngIf="showRoomPreview" class="flex gap-1.5">
              <img *ngFor="let room of rooms" [src]="room.thumb" [alt]="room.label"
                (click)="selectRoom(room.slug)"
                [class]="'w-12 h-9 object-cover rounded cursor-pointer border-2 transition-all '
                  + (roomType === room.slug ? 'border-[#8B1A1A]' : 'border-gray-200 hover:border-gray-400')" />
            </div>
          </div>
        </div>

        <!-- ══ RIGHT: TABS + CONTENT ══ -->
        <div>
          <!-- Desktop tab bar (inside right column) -->
          <div class="hidden md:flex gap-2 flex-wrap mb-5">
            <button *ngFor="let tab of visibleTabs" (click)="setTab(tab.slug)"
              [class]="'px-5 py-2.5 text-[13px] font-semibold rounded transition-all whitespace-nowrap '
                + (activeTab === tab.slug ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
              {{ tab.name }}
            </button>
          </div>

          <!-- TAB: Product -->
          <div *ngIf="activeTab === 'product'">
            <div class="bg-[#e8e8e8] text-center py-3 px-4 mb-4 rounded">
              <h3 class="text-base font-bold text-gray-800">Select your product</h3>
            </div>
            <div class="grid grid-cols-4 gap-3">
              <ng-container *ngFor="let pt of productTypes">
                <div *ngIf="pt.slug !== 'poster'" class="text-center">
                  <div (click)="onProductType(pt)"
                    [class]="'relative overflow-hidden cursor-pointer transition-all border-3 '
                      + (productType?.slug === pt.slug ? 'border-[#8B1A1A] shadow-lg' : 'border-transparent')">
                    <div *ngIf="productType?.slug === pt.slug"
                      class="absolute -top-1 -right-1 z-10">
                      <svg class="w-6 h-6 text-[#8B1A1A] bg-white rounded-full" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                    </div>
                    <img *ngIf="pt.image" [src]="pt.image" [alt]="pt.name" class="w-full aspect-[4/3] object-cover" />
                    <div *ngIf="!pt.image" class="w-full aspect-[4/3] bg-gray-100 flex items-center justify-center">
                      <span class="text-[10px] text-gray-400">{{ pt.name }}</span>
                    </div>
                  </div>
                  <button (click)="onProductType(pt)"
                    [class]="'w-full mt-2 py-2 text-[13px] font-semibold rounded transition-all text-center '
                      + (productType?.slug === pt.slug ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                    {{ pt.name }}
                  </button>
                </div>
              </ng-container>
            </div>
            <div *ngIf="productType?.slug === 'frame_only'" class="mt-3 bg-yellow-50 border border-yellow-300 text-yellow-800 text-xs px-3 py-2 rounded">
              * ONLY FRAME WILL BE DELIVERED.
            </div>
          </div>

          <!-- TAB: Upload Image / Print Size -->
          <div *ngIf="activeTab === 'photo'">
            <!-- Upload section — hidden for wall_art (stock image pre-loaded) -->
            <div *ngIf="!stockImageId" class="flex flex-wrap gap-3 mb-5">
              <!-- Upload button -->
              <div class="w-[calc(50%-6px)] md:w-[28%]">
                <button (click)="onAddPhoto($event)"
                  class="w-full border-2 border-dashed border-gray-400 py-5 px-3 text-center hover:border-[#8B1A1A] transition-colors rounded">
                  <h4 class="text-sm font-bold text-[#8B1A1A] mb-1">Upload Your Image</h4>
                  <p class="text-[11px] text-[#8B1A1A]">Drag or Drop Your Images</p>
                  <p class="text-[11px] text-gray-400">or</p>
                  <p class="text-[11px] text-[#8B1A1A] font-semibold underline">Click to Browse</p>
                </button>
              </div>
              <!-- Uploaded photos -->
              <div *ngFor="let photo of myPhotos; let i = index" class="w-[calc(28%-6px)] md:w-[15%]">
                <div (click)="onPhoto(i)"
                  [class]="'relative border-2 rounded overflow-hidden cursor-pointer '
                    + (activePhotoIndex === i ? 'border-[#8B1A1A] shadow-lg' : 'border-gray-200')">
                  <div class="absolute top-1 right-1 z-10 cursor-pointer text-red-500 hover:text-red-700" (click)="onRemovePhoto($event, i)">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></svg>
                  </div>
                  <img [src]="photo" class="w-full h-[90px] object-cover" />
                </div>
              </div>
              <div *ngIf="uploading" class="flex items-center">
                <div class="w-5 h-5 border-2 border-[#8B1A1A] border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>

            <!-- IMAGE FILTER — same list the sales panel shows (settings.p2f.image_filters) -->
            <div *ngIf="imageFilters.length" class="mb-5">
              <h4 class="text-[12px] md:text-[13px] font-bold text-gray-800 uppercase tracking-wider mb-2">Image Filter:</h4>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let f of imageFilters" (click)="selectImageFilter(f.name)"
                  [class]="'rounded px-3 py-1.5 text-center transition-all '
                    + (selectedImageFilter === f.name ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-700 hover:bg-gray-200')">
                  <img *ngIf="imagePath" [src]="imagePath" [style.filter]="f.css || null"
                    class="mx-auto mb-1 h-10 w-12 rounded object-cover" />
                  <span class="text-[11px] md:text-[12px] font-semibold">{{ f.name }}</span>
                </button>
              </div>
            </div>

            <!-- IMAGE SIZES -->
            <div class="mb-5">
              <h4 class="text-[12px] md:text-[13px] font-bold text-gray-800 uppercase tracking-wider mb-2">Image Sizes:</h4>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let size of printSizes" (click)="onPrintSizeChange(size)"
                  [class]="'px-3 md:px-5 py-1.5 md:py-2 text-[11px] md:text-[13px] font-semibold rounded-full transition-all '
                    + (printSize === size ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-700 hover:bg-gray-200')">
                  {{ size }}
                </button>
              </div>
            </div>

            <!-- CUSTOM SIZES -->
            <div>
              <h4 class="text-[12px] md:text-[13px] font-bold text-gray-800 uppercase tracking-wider mb-2">Custom Sizes:</h4>
              <div class="flex items-end gap-3">
                <div class="flex flex-col">
                  <label class="text-[10px] text-gray-400 mb-1">Width</label>
                  <input type="number" [(ngModel)]="printSizeCustomWidth" (blur)="onCustomWidthChange()"
                    class="w-[70px] md:w-[90px] h-9 md:h-10 border border-gray-300 rounded-lg text-center text-sm outline-none focus:border-[#8B1A1A] bg-white" />
                </div>
                <div class="flex flex-col">
                  <label class="text-[10px] text-gray-400 mb-1">Height</label>
                  <input type="number" [(ngModel)]="printSizeCustomHeight" (blur)="onCustomHeightChange()"
                    class="w-[70px] md:w-[90px] h-9 md:h-10 border border-gray-300 rounded-lg text-center text-sm outline-none focus:border-[#8B1A1A] bg-white" />
                </div>
                <strong class="text-sm text-gray-700 pb-2">Inches</strong>
              </div>
            </div>
          </div>

          <!-- TAB: Print Surface (Glossy / Matte columns) -->
          <div *ngIf="activeTab === 'print'">
            <p class="text-[12px] text-[#8B1A1A] mb-4 font-semibold">* Marked Surface are the Premium Surfaces</p>
            <div class="grid grid-cols-2 gap-5">
              <!-- Glossy -->
              <div>
                <div class="bg-[#e8e8e8] border border-gray-400 text-center py-2.5 rounded mb-3">
                  <strong class="text-[14px] text-gray-800">Glossy</strong>
                </div>
                <div class="space-y-2">
                  <ng-container *ngFor="let paper of papers">
                    <button *ngIf="paper.category_id == 2" (click)="onPrintSurface(paper)"
                      [class]="'w-full py-2.5 px-3 text-[13px] font-medium rounded transition-all text-center relative '
                        + (printSurface?.id === paper.id ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-700 hover:bg-gray-200')">
                      {{ paper.display_name || paper.name }}
                      <span *ngIf="paper.print_quality === 'premium'"> *</span>
                      <span *ngIf="paper.dis > 0"
                        class="absolute -top-2 -right-2 bg-green-600 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                        {{ paper.dis }}%
                      </span>
                    </button>
                  </ng-container>
                </div>
              </div>
              <!-- Matte -->
              <div>
                <div class="bg-[#e8e8e8] border border-gray-400 text-center py-2.5 rounded mb-3">
                  <strong class="text-[14px] text-gray-800">Matte</strong>
                </div>
                <div class="space-y-2">
                  <ng-container *ngFor="let paper of papers">
                    <button *ngIf="paper.category_id == 1" (click)="onPrintSurface(paper)"
                      [class]="'w-full py-2.5 px-3 text-[13px] font-medium rounded transition-all text-center relative '
                        + (printSurface?.id === paper.id ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-700 hover:bg-gray-200')">
                      {{ paper.display_name || paper.name }}
                      <span *ngIf="paper.print_quality === 'premium'"> *</span>
                      <span *ngIf="paper.dis > 0"
                        class="absolute -top-2 -right-2 bg-green-600 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                        {{ paper.dis }}%
                      </span>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB: Mount & Glass -->
          <div *ngIf="activeTab === 'mount'">
            <!-- Mount toggle -->
            <div class="flex items-center gap-4 mb-6">
              <h4 class="text-[14px] font-bold text-gray-900 uppercase tracking-wide">Mount</h4>
              <div class="flex gap-2">
                <button (click)="showMount(true)"
                  [class]="'px-6 py-2.5 text-[13px] font-semibold rounded transition-all '
                    + (isShowMount ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  With Mount
                </button>
                <button (click)="showMount(false)"
                  [class]="'px-6 py-2.5 text-[13px] font-semibold rounded transition-all '
                    + (!isShowMount ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  Without Mount
                </button>
              </div>
            </div>

            <div *ngIf="isShowMount">
              <!-- Mount Width -->
              <div class="flex items-start gap-4 mb-5">
                <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide whitespace-nowrap pt-1">Mount Width:</h4>
                <div class="flex flex-wrap gap-2">
                  <button *ngFor="let w of matWidths" (click)="onMountSizeChange(1, w)"
                    [class]="'px-5 py-2 text-[13px] font-semibold rounded transition-all min-w-[50px] text-center '
                      + (mountSize1 === w ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                    {{ w }}
                  </button>
                </div>
              </div>

              <!-- Mount Color -->
              <div class="mb-5">
                <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide mb-3">Mount Color:</h4>
                <div class="grid grid-cols-2 gap-3">
                  <div *ngFor="let m of mounts" (click)="onMount(m, 1)"
                    [class]="'relative flex items-center gap-3 cursor-pointer transition-all rounded overflow-hidden pr-2 '
                      + (mount1?.id === m.id ? 'ring-2 ring-[#8B1A1A]' : 'hover:ring-1 hover:ring-gray-300')">
                    <span class="text-[12px] text-gray-700 font-medium w-[110px] shrink-0 pl-2">{{ m.name }}</span>
                    <div class="flex-1 h-[50px] overflow-hidden">
                      <img *ngIf="m.image_1 || m.image" [src]="m.image_1 || m.image" [alt]="m.name" class="w-full h-full object-cover" />
                      <div *ngIf="!m.image_1 && !m.image" [style.background]="m.hex || '#ccc'" class="w-full h-full"></div>
                    </div>
                    <div *ngIf="mount1?.id === m.id"
                      class="absolute bottom-1 right-1 text-[#8B1A1A]">
                      <svg class="w-5 h-5 bg-white rounded-full" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Glass -->
            <div class="flex items-center gap-4 mt-4">
              <h4 class="text-[14px] font-bold text-gray-900 uppercase tracking-wide">Glass:</h4>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let g of glasses" (click)="onGlass(g)"
                  [class]="'px-6 py-2.5 text-[13px] font-semibold rounded transition-all relative '
                    + (glass?.id === g.id ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  {{ g.name }}
                  <span *ngIf="g.discount_per > 0"
                    class="absolute -top-2 -right-2 bg-green-600 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                    {{ g.discount_per }}%
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- TAB: Frames -->
          <div *ngIf="activeTab === 'frames'">
            <!-- 2-column form layout: labels left, buttons right -->
            <div class="grid grid-cols-1 md:grid-cols-[140px_1fr] gap-y-3 md:gap-y-4 gap-x-4 items-start">

              <!-- Frame Sizes -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Frame Sizes:</h4>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let w of frameWidths" (click)="onFrameWidthChange(String(w))"
                  [class]="'px-5 py-2 text-[13px] font-semibold rounded transition-all min-w-[55px] text-center '
                    + (selectedFrameWidth == w ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  {{ w }}"
                </button>
              </div>

              <!-- Frame Materials -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Frame Materials:</h4>
              <div class="flex flex-wrap gap-2">
                <ng-container *ngFor="let m of frameMaterials">
                  <button *ngIf="allowedMaterialIds.includes(m.id)" (click)="onFrameMaterialChange(m.id)"
                    [class]="'px-5 py-2 text-[13px] font-semibold rounded transition-all '
                      + (selectedFrameMaterial === m.id ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                    {{ m.name }}
                  </button>
                </ng-container>
              </div>

              <!-- Frame Styles -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Frame Styles:</h4>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
                <!-- "All Styles" only shows if more than 1 style available -->
                <button *ngIf="allowedStylesIds.length > 1" (click)="onFrameStyleChange(0)"
                  [class]="'py-2 text-[13px] font-semibold rounded transition-all text-center '
                    + (!selectedFrameStyle ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  All Styles
                </button>
                <ng-container *ngFor="let s of frameStyles">
                  <button *ngIf="allowedStylesIds.includes(s.id)" (click)="onFrameStyleChange(s.id)"
                    [class]="'py-2 text-[13px] font-semibold rounded transition-all text-center '
                      + (selectedFrameStyle === s.id ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                    {{ s.name }}
                  </button>
                </ng-container>
              </div>

              <!-- Frame Colors -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Frame Colors:</h4>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
                <!-- "All Colors" only shows if more than 1 color available -->
                <button *ngIf="allowedColors.length > 1" (click)="onFrameColorChange('')"
                  [class]="'py-2 text-[13px] font-semibold rounded transition-all text-center '
                    + (!selectedFrameColor ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                  All Colors
                </button>
                <ng-container *ngFor="let c of frameColors">
                  <button *ngIf="allowedColors.includes(c)"
                    (click)="onFrameColorChange(c)"
                    [class]="'py-2 text-[13px] font-semibold rounded transition-all text-center '
                      + (selectedFrameColor === c ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">
                    {{ c }}
                  </button>
                </ng-container>
              </div>

              <!-- Rounded Shape — same option the sales panel offers -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Rounded Shape:</h4>
              <div class="flex gap-2">
                <button (click)="setRoundedShape(false)"
                  [class]="'min-w-[55px] px-5 py-2 text-[13px] font-semibold rounded transition-all text-center '
                    + (!roundedShape ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">No</button>
                <button (click)="setRoundedShape(true)"
                  [class]="'min-w-[55px] px-5 py-2 text-[13px] font-semibold rounded transition-all text-center '
                    + (roundedShape ? 'bg-[#8B1A1A] text-white' : 'bg-[#f0f0f0] text-gray-600 hover:bg-gray-200')">Yes</button>
              </div>

              <!-- Frame Options -->
              <h4 class="text-[13px] font-bold text-gray-900 uppercase tracking-wide pt-2">Frame Options:</h4>
              <div></div>
            </div>

            <!-- Frame Options grid (full width below the form) -->
            <div class="grid grid-cols-4 md:grid-cols-8 gap-2">
              <div *ngFor="let f of filteredFrames" class="text-center">
                <button (click)="onFrame(f)" [disabled]="f.disabled"
                  [class]="'relative overflow-hidden transition-all w-full border-2 '
                    + (f.disabled ? 'opacity-[0.15] cursor-not-allowed border-transparent' : (frame?.id === f.id ? 'border-[#8B1A1A] shadow-md' : 'border-transparent hover:border-gray-300'))">
                  <div *ngIf="frame?.id === f.id"
                    class="absolute bottom-0 right-0 z-10 text-[#8B1A1A]">
                    <svg class="w-4 h-4 bg-white rounded-full" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                  </div>
                  <span *ngIf="f.discount_per > 0"
                    class="absolute top-0 right-0 bg-green-600 text-white text-[7px] font-bold px-1 py-0.5 rounded-bl z-10">
                    -{{ f.discount_per }}%
                  </span>
                  <img [src]="f.L_frame_image || f.image" [alt]="f.frame_name || f.name"
                    class="w-full aspect-square object-contain" />
                </button>
                <p class="text-[9px] text-gray-600 mt-1 leading-tight font-medium">{{ f.frame_name || f.name }}</p>
              </div>
            </div>
            <div *ngIf="filteredFrames.length === 0" class="text-center py-6 text-sm text-gray-400">
              No frames match the selected filters
            </div>
          </div>

          <!-- TAB: Canvas -->
          <div *ngIf="activeTab === 'canvas'">
            <h3 class="text-[15px] font-bold text-gray-800 mb-4">Canvas Wrap</h3>
            <div class="flex flex-wrap gap-4">
              <div *ngFor="let w of canvasWraps" class="w-[calc(50%-8px)] md:w-[calc(33%-11px)] text-center">
                <div (click)="onCanvasWrap(w)"
                  [class]="'border-2 rounded overflow-hidden cursor-pointer transition-all '
                    + (canvasWrap?.slug === w.slug ? 'border-[#8B1A1A] shadow-lg' : 'border-gray-200')">
                  <img [src]="(w.image || '').replace('/wall_art/','/frame_photos/')" [alt]="w.name"
                    class="w-full aspect-square object-contain p-2"
                    (error)="$any($event.target).src = 'assets/images/mahattaart/product_icons/canvas_gallery.jpg'" />
                </div>
                <button (click)="onCanvasWrap(w)"
                  [class]="'w-full mt-1 py-1.5 text-[11px] font-bold rounded border-2 transition-all '
                    + (canvasWrap?.slug === w.slug ? 'bg-[#8B1A1A] text-white border-[#8B1A1A]' : 'bg-white text-gray-600 border-gray-300')">
                  {{ w.name }}
                </button>
              </div>
            </div>
          </div>

          <!-- PREVIOUS / NEXT -->
          <div class="flex justify-between items-center mt-6 pt-4">
            <button (click)="prevTab()" [disabled]="isFirstTab"
              [class]="'flex items-center gap-1 text-sm font-semibold transition-colors '
                + (isFirstTab ? 'text-gray-300 cursor-not-allowed' : 'text-gray-400 hover:text-[#8B1A1A]')">
              <span class="text-lg">&#9664;&#9664;</span> Previous
            </button>
            <button (click)="nextTab()" [disabled]="isLastTab"
              [class]="'flex items-center gap-1 text-sm font-bold transition-colors '
                + (isLastTab ? 'text-gray-300 cursor-not-allowed' : 'text-[#8B1A1A] hover:text-[#6d1414]')">
              Next <span class="text-lg">&#9654;&#9654;</span>
            </button>
          </div>

          <!-- ═══ PRODUCT OVERVIEW — always visible; unselected fields read "—" ═══ -->
          <div class="bg-[#e1e1e1] rounded-[20px] overflow-hidden shadow-sm px-3 md:px-4 py-3 mt-5" style="font-size:0.8rem;">
            <h3 class="text-center text-[14px] md:text-[15px] font-bold text-gray-800 mb-3" style="font-family:'Roboto Slab',serif;">
              Product Overview
            </h3>
            <div class="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-x-6 gap-y-1">
              <!-- Details -->
              <div>
                <div *ngIf="productTypeSlug !== 'frame_only'" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Print Size</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ printSize || '—' }}</span></div>
                <div *ngIf="isTabVisible('print')" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Print Surface</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ printSurface?.display_name || printSurface?.name || '—' }}</span></div>
                <div *ngIf="isTabVisible('mount')" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Mount</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ mount1 ? mount1.name + ' (' + mountSize1 + '")' : '—' }}</span></div>
                <div *ngIf="isTabVisible('mount') && previewLayout !== 'canvas'" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Glass</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ glass?.name || '—' }}</span></div>
                <div *ngIf="isTabVisible('frames')" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Frame</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ frame?.frame_name || frame?.name || '—' }}</span></div>
                <div *ngIf="isTabVisible('canvas')" class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Wrap</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ canvasWrap?.name || '—' }}</span></div>
                <div class="flex py-0.5"><span class="font-bold text-gray-800 w-[110px] md:w-[130px] shrink-0 text-[11px] md:text-[13px]">Final Size</span><span class="text-gray-600 text-[11px] md:text-[13px]">: {{ finalFrameSize || printSize || '—' }}</span></div>
              </div>
              <!-- Pricing -->
              <div class="mt-2 md:mt-0 md:min-w-[180px]">
                <div class="flex py-0.5"><span class="font-bold text-gray-800 w-[100px] md:w-[110px] shrink-0 text-[11px] md:text-[13px]">Price</span><span *ngIf="mrp" class="text-gray-500 text-[11px] md:text-[13px]">: <span class="line-through">&#8377;{{ mrp | number:'1.2-2' }}</span></span><span *ngIf="!mrp" class="text-gray-400">: —</span></div>
                <div class="flex py-0.5 items-center"><span class="font-bold text-gray-800 w-[100px] md:w-[110px] shrink-0 text-[11px] md:text-[13px]">Effective Price</span><span *ngIf="priceLoading" class="flex items-center gap-1.5 text-[#8B1A1A] font-semibold text-[11px] md:text-[13px]">: <span class="w-3.5 h-3.5 border-2 border-[#8B1A1A] border-t-transparent rounded-full animate-spin inline-block"></span> Calculating…</span><span *ngIf="!priceLoading && effectivePrice" class="text-[#8B1A1A] font-bold text-[11px] md:text-[13px]">: &#8377;{{ effectivePrice | number:'1.2-2' }}</span><span *ngIf="!priceLoading && !effectivePrice" class="text-gray-400">: —</span></div>
                <div class="flex py-0.5"><span class="font-bold text-gray-800 w-[100px] md:w-[110px] shrink-0 text-[11px] md:text-[13px]">Offer</span><span *ngIf="offerPercent" class="text-green-700 font-semibold text-[11px] md:text-[13px]">: Save {{ offerPercent }}%</span><span *ngIf="!offerPercent" class="text-gray-400">: —</span></div>
                <!-- Desktop buttons -->
                <div class="hidden md:flex gap-2 mt-3">
                  <button type="button" (click)="addToCart()" [disabled]="!canAddToCart || addingToCart || priceLoading"
                    [class]="'flex-1 py-2 text-[12px] font-bold rounded-full transition-all '
                      + (canAddToCart && !addingToCart && !priceLoading ? 'bg-[#3a7d44] text-white hover:bg-[#2e6336]' : 'bg-gray-300 text-gray-500 cursor-not-allowed')">
                    {{ addingToCart ? 'Adding...' : (priceLoading ? 'Calculating…' : 'Add To Cart') }}
                  </button>
                  <button type="button" (click)="buyNow()" [disabled]="!canAddToCart || addingToCart || priceLoading"
                    [class]="'flex-1 py-2 text-[12px] font-bold rounded-full transition-all '
                      + (canAddToCart && !addingToCart && !priceLoading ? 'bg-[#8B1A1A] text-white hover:bg-[#6d1414]' : 'bg-gray-300 text-gray-500 cursor-not-allowed')">
                    {{ addingToCart ? 'Please wait…' : 'Buy Now' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- cart success moved to fixed toast at top -->

          <!-- ═══ TRUST BADGES (inside right column — responsive) ═══ -->
          <div class="bg-[#e1e1e1] rounded-[20px] py-3 md:py-4 px-3 md:px-4 shadow-sm mt-4">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-center">
              <div class="flex flex-col items-center gap-1">
                <img src="https://content.mahattaart.com/icons/icon10.png" alt="Delivery" class="w-8 md:w-9 h-8 md:h-9 object-contain" (error)="$any($event.target).style.display='none'" />
                <div><p class="text-[9px] md:text-[10px] font-bold text-gray-800">PAN India Delivery</p><p class="text-[8px] md:text-[9px] text-gray-500">Delhi NCR 2-3 Days</p><p class="text-[8px] md:text-[9px] text-gray-500">Other States 5-8 Days</p></div>
              </div>
              <div class="flex flex-col items-center gap-1">
                <img src="https://content.mahattaart.com/icons/icon5.png" alt="Price" class="w-8 md:w-9 h-8 md:h-9 object-contain" (error)="$any($event.target).style.display='none'" />
                <div><p class="text-[9px] md:text-[10px] font-bold text-gray-800">Affordable Price</p><p class="text-[8px] md:text-[9px] text-gray-500">&amp; Premium Quality</p></div>
              </div>
              <div class="flex flex-col items-center gap-1">
                <img src="https://content.mahattaart.com/icons/icon9.png" alt="Safe" class="w-8 md:w-9 h-8 md:h-9 object-contain" (error)="$any($event.target).style.display='none'" />
                <div><p class="text-[9px] md:text-[10px] font-bold text-gray-800">100% Safe</p><p class="text-[8px] md:text-[9px] text-gray-500">&amp; Secure Payments</p></div>
              </div>
              <div class="flex flex-col items-center gap-1">
                <img src="https://content.mahattaart.com/icons/icon7.png" alt="Support" class="w-8 md:w-9 h-8 md:h-9 object-contain" (error)="$any($event.target).style.display='none'" />
                <div><p class="text-[9px] md:text-[10px] font-bold text-gray-800">Customer Support</p><p class="text-[8px] md:text-[9px] text-gray-500">Mon-Sat 10AM-7PM</p></div>
              </div>
            </div>
          </div>

        </div>
        <!-- END RIGHT COLUMN -->
      </div>
    </div>

    <!-- ═══ MOBILE STICKY PRICE BAR (fixed bottom) ═══ -->
    <div class="md:hidden fixed bottom-0 left-0 right-0 z-40 px-4 py-3 shadow-[0_-2px_10px_rgba(0,0,0,0.15)]"
      style="background:rgb(253,245,245);">
      <div class="flex items-center justify-between">
        <div>
          <div *ngIf="priceLoading" class="flex items-center gap-2">
            <span class="w-4 h-4 border-2 border-[#8B1A1A] border-t-transparent rounded-full animate-spin inline-block"></span>
            <span class="text-sm font-semibold text-gray-700">Calculating…</span>
          </div>
          <div *ngIf="!priceLoading && payable" class="flex items-baseline gap-2">
            <span class="text-lg font-bold text-gray-900">&#8377;{{ payable | number:'1.0-0' }}</span>
            <span *ngIf="discount > 0" class="text-xs text-gray-400 line-through">&#8377;{{ (payable + discount) | number:'1.0-0' }}</span>
          </div>
          <span *ngIf="offerPercent" class="text-[10px] text-green-700 font-semibold">Save {{ offerPercent }}%</span>
          <p class="text-[9px] text-gray-400">Excl. shipping</p>
        </div>
        <div class="flex gap-2">
          <button type="button" (click)="buyNow()" [disabled]="!canAddToCart || addingToCart || priceLoading"
            [class]="'px-5 py-2 text-[11px] font-bold rounded-full ' + (canAddToCart && !addingToCart && !priceLoading ? 'bg-[#8B1A1A] text-white' : 'bg-gray-300 text-gray-500')">
            {{ addingToCart ? 'Please wait…' : 'Buy Now' }}
          </button>
          <button type="button" (click)="addToCart()" [disabled]="!canAddToCart || addingToCart || priceLoading"
            [class]="'px-5 py-2 text-[11px] font-bold rounded-full border-2 ' + (canAddToCart && !addingToCart && !priceLoading ? 'bg-white text-[#8B1A1A] border-[#8B1A1A]' : 'bg-gray-100 text-gray-400 border-gray-300')">
            {{ addingToCart ? 'Adding…' : 'Add To Cart' }}
          </button>
        </div>
      </div>
    </div>
    <!-- Spacer for mobile sticky bar -->
    <div class="md:hidden h-[70px]"></div>

    <!-- ═══ CUSTOMER REVIEWS ═══ -->
    <div class="bg-white py-8 md:py-10">
      <div class="max-w-[1100px] mx-auto px-4">
        <h2 class="text-xl md:text-2xl text-center text-gray-900 mb-2" style="font-family:'Roboto Slab',serif;">
          What Customer Say About Us?
        </h2>
        <div class="flex items-center justify-center mb-6">
          <img src="assets/images/common/H1-separator.png" alt="" class="h-5" (error)="$any($event.target).style.display='none'" />
        </div>
        <div class="relative">
          <button (click)="scrollReviews(-1)" *ngIf="reviewScrollIndex > 0"
            class="absolute left-0 top-1/2 -translate-y-1/2 -ml-3 z-10 w-8 h-8 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow">
            <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <div class="overflow-hidden">
            <div class="flex transition-transform duration-300" [style.transform]="'translateX(-' + (reviewScrollIndex * 20) + '%)'">
              <div *ngFor="let review of reviews" class="w-1/2 md:w-1/5 flex-shrink-0 px-3">
                <div class="text-center">
                  <div class="flex justify-center gap-0.5 mb-2">
                    <span *ngFor="let s of [1,2,3,4,5]" class="text-yellow-500 text-sm">&#9733;</span>
                  </div>
                  <p class="text-xs text-gray-600 leading-relaxed mb-3 min-h-[80px]">{{ review.text }}</p>
                  <a class="text-[11px] text-blue-600 underline cursor-pointer">Read more..</a>
                  <p class="text-xs font-bold text-gray-800 mt-2">{{ review.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <button (click)="scrollReviews(1)" *ngIf="reviewScrollIndex < reviews.length - 3"
            class="absolute right-0 top-1/2 -translate-y-1/2 -mr-3 z-10 w-8 h-8 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow">
            <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- ═══ GET IN TOUCH (Reactive Form) ═══ -->
    <div class="py-8 md:py-10" style="background:rgb(253,245,245);">
      <div class="max-w-[900px] mx-auto px-4">
        <div class="text-center mb-6">
          <h2 class="text-xl md:text-2xl text-gray-900" style="font-family:'Roboto Slab',serif;">Get In Touch</h2>
          <p class="text-xs text-gray-500 mt-1">Send us a message, we will respond shortly.</p>
          <div class="flex items-center justify-center mt-2">
            <img src="assets/images/common/H1-separator.png" alt="" class="h-5" (error)="$any($event.target).style.display='none'" />
          </div>
        </div>
        <div *ngIf="formSuccess" class="bg-green-50 border border-green-200 text-green-700 text-sm text-center py-3 px-4 mb-4">
          Thank you for contacting us. Our agent will contact you within 24 hours.
        </div>
        <div *ngIf="formError" class="bg-red-50 border border-red-200 text-red-700 text-sm text-center py-3 px-4 mb-4">
          There is some error. Please try again.
        </div>
        <form [formGroup]="queryForm" (ngSubmit)="submitQuery()">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="space-y-4">
              <!-- Name -->
              <div>
                <input formControlName="name" type="text" placeholder="Name *"
                  [class]="'w-full border bg-white px-4 py-2.5 text-sm outline-none transition-colors '
                    + (f['name'].touched && f['name'].invalid ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-[#8B1A1A]')" />
                <p *ngIf="f['name'].touched && f['name'].errors && f['name'].errors['required']" class="text-[10px] text-red-500 mt-1">Name is required</p>
                <p *ngIf="f['name'].touched && f['name'].errors && f['name'].errors['minlength']" class="text-[10px] text-red-500 mt-1">Name must be at least 2 characters</p>
              </div>
              <!-- Email -->
              <div>
                <input formControlName="email" type="email" placeholder="Email *"
                  [class]="'w-full border bg-white px-4 py-2.5 text-sm outline-none transition-colors '
                    + (f['email'].touched && f['email'].invalid ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-[#8B1A1A]')" />
                <p *ngIf="f['email'].touched && f['email'].errors && f['email'].errors['required']" class="text-[10px] text-red-500 mt-1">Email is required</p>
                <p *ngIf="f['email'].touched && f['email'].errors && f['email'].errors['email']" class="text-[10px] text-red-500 mt-1">Please enter a valid email address</p>
              </div>
              <!-- Contact -->
              <div>
                <input formControlName="contact" type="text" placeholder="Contact *" maxlength="10"
                  [class]="'w-full border bg-white px-4 py-2.5 text-sm outline-none transition-colors '
                    + (f['contact'].touched && f['contact'].invalid ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-[#8B1A1A]')" />
                <p *ngIf="f['contact'].touched && f['contact'].errors && f['contact'].errors['required']" class="text-[10px] text-red-500 mt-1">Contact number is required</p>
                <p *ngIf="f['contact'].touched && f['contact'].errors && f['contact'].errors['pattern']" class="text-[10px] text-red-500 mt-1">Enter a valid 10-digit mobile number</p>
              </div>
            </div>
            <div>
              <!-- Query -->
              <div class="h-full">
                <textarea formControlName="requirement" placeholder="Query *" rows="4"
                  [class]="'w-full border bg-white px-4 py-2.5 text-sm outline-none transition-colors resize-none h-full min-h-[140px] '
                    + (f['requirement'].touched && f['requirement'].invalid ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-[#8B1A1A]')"></textarea>
                <p *ngIf="f['requirement'].touched && f['requirement'].errors && f['requirement'].errors['required']" class="text-[10px] text-red-500 mt-1">Query is required</p>
                <p *ngIf="f['requirement'].touched && f['requirement'].errors && f['requirement'].errors['minlength']" class="text-[10px] text-red-500 mt-1">Query must be at least 5 characters</p>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <button type="submit" [disabled]="formSubmitting"
              class="bg-[#8B1A1A] text-white px-8 py-2.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#6d1414] transition-all disabled:opacity-50">
              {{ formSubmitting ? 'SENDING...' : 'SEND QUERY' }}
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>

<!-- Validation dialog is rendered at app root level via <app-validation-dialog> -->
